import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon, SaveIcon, CheckIcon } from 'lucide-react';
export function QuoteStepNavigation({
  currentStep,
  totalSteps,
  onNext,
  onBack,
  onSave,
  isFinalStep = false
}) {
  return <div className="mt-8 pt-6 border-t border-blue-800/30 flex justify-between" data-id="element-5118" data-mp="23yjg76i49dje">
      <button onClick={onBack} className="flex items-center px-4 py-2.5 rounded-lg bg-slate-700/50 text-blue-300 hover:bg-slate-700 hover:text-white transition-colors" disabled={currentStep === 0} data-id="element-5119" data-mp="1zwg024ki5krs">
        <ArrowLeftIcon size={18} className="mr-2" data-id="element-5120" data-mp="2rmkl85g36bu2" />
        Back
      </button>
      <div className="flex gap-3" data-id="element-5121" data-mp="2nlh2nb6nm1p5">
        <button onClick={onSave} className="flex items-center px-4 py-2.5 rounded-lg bg-blue-600/20 text-blue-300 hover:bg-blue-600/40 hover:text-white transition-colors" data-id="element-5122" data-mp="2nkfrz7tjvh7y">
          <SaveIcon size={18} className="mr-2" data-id="element-5123" data-mp="1c62ackpe3y0d" />
          Save Draft
        </button>
        <button onClick={onNext} className="flex items-center px-5 py-2.5 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-colors" data-id="element-5124" data-mp="1778u4kipxswi">
          {isFinalStep ? <>
              <CheckIcon size={18} className="mr-2" data-id="element-5125" data-mp="348m4e3jtghzq" />
              Submit Quote
            </> : <>
              Next
              <ArrowRightIcon size={18} className="ml-2" data-id="element-5126" data-mp="2va0qilpahr5a" />
            </>}
        </button>
      </div>
    </div>;
}